import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { TransferOperatingHours } from '../transfers';

interface Props {
  windows: TransferOperatingHours[];
}

/** Ventanas contractuales, compartidas por la card y el detalle pre-hold. */
export function TransferOperatingHoursSection({ windows }: Props) {
  const { t } = useTranslation();
  if (windows.length === 0) return null;

  return (
    <Box mt={0.75}>
      <Typography variant="caption" color="text.secondary" display="block">
        {t('travelServices.transfers.operatingHours')}
      </Typography>
      {windows.map((window, position) => (
        <Typography key={position} variant="caption" display="block">
          {`${window.daysOfWeek
            .map((day) => t(`travelServices.transfers.days.${day}`))
            .join(', ')}: ${
            window.opensAt === '00:00' && window.closesAt === '00:00'
              ? t('travelServices.transfers.allDay')
              : `${window.opensAt}–${window.closesAt}`
          }`}
        </Typography>
      ))}
    </Box>
  );
}
